import { render, staticRenderFns } from "./middle-page.vue?vue&type=template&id=72fa7a1c"
import script from "./middle-page.vue?vue&type=script&lang=js"
export * from "./middle-page.vue?vue&type=script&lang=js"
import style0 from "./middle-page.vue?vue&type=style&index=0&id=72fa7a1c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports